/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { object, array, string, func, number } from 'prop-types';

import { CHECKBOX, SELECT, RANGE } from 'actions/search';

import Checkbox from 'components/Form/Input/Checkbox/Checkbox';
import Select from 'components/Form/Input/Select/Select';

import styles from './selector.scss';

/**
 * This is the Selector component.
 *
 * @author Erwan Lemonnier
 */
export class Selector extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    name: string.isRequired,
    type: string.isRequired,
    label: string.isRequired,
    formInput: object,
    select_tags: array,
    range_left_param: string,
    range_right_param: string,
    onChange: func,
  };

  static defaultProps = {
    name: null,
    formInput: {},
    select_tags: [],
    range_left_param: null,
    range_right_param: null,
    checkbox_active: false,
    onChange: () => {},
  };

  onChange = event => {
    const { type, name, onChange } = this.props;
    const value = type === CHECKBOX ? event.target.checked : event.target.value;
    let key = 'value';

    onChange(name, value, key, type);
  };

  renderCheckbox = () => {
    const {
      name,
      label,
      formInput: { value },
    } = this.props;

    return (
      <label className={styles.checkbox} htmlFor={name}>
        <Checkbox name={name} value={value || false} onChange={this.onChange} />
        <p className={styles.label}>{label}</p>
      </label>
    );
  };

  renderRange = () => {
    const {
      label,
      range_left_param,
      range_right_param,
      name,
      type,
      onChange,
      formInput,
    } = this.props;

    return (
      <React.Fragment>
        <p className={styles.label}>{label}</p>
        <div className={styles.rangeWrapper}>
          <input
            className={styles.range}
            type="number"
            value={formInput[range_left_param]}
            name={name}
            onChange={e =>
              onChange(name, Number(e.target.value), range_left_param, type)
            }
          />
          <input
            className={styles.range}
            type="number"
            value={formInput[range_right_param]}
            name={name}
            onChange={e =>
              onChange(name, Number(e.target.value), range_right_param, type)
            }
          />
        </div>
      </React.Fragment>
    );
  };

  renderSelect = () => {
    const {
      name,
      label,
      select_tags,
      formInput: { value },
    } = this.props;

    const options = select_tags.map(tag => ({
      [tag.tag]: tag.label,
    }));

    return (
      <React.Fragment>
        <p className={styles.label}>{label}</p>
        <Select
          name={name}
          value={value}
          options={options}
          onChange={this.onChange}
          small
        />
      </React.Fragment>
    );
  };

  renderInput = () => {
    const { type } = this.props;

    switch (type) {
      case CHECKBOX:
        return this.renderCheckbox();

      case RANGE:
        return this.renderRange();

      case SELECT:
        return this.renderSelect();

      default:
        return null;
    }
  };

  /**
   * Render Selector.
   *
   * @return {Object}
   */
  render() {
    return <div className={styles.wrapper}>{this.renderInput()}</div>;
  }
}

export default Selector;
